export const formTitle = 'Request Custom/Onsite Training';
export const link = 'Submit';
